import { settleOrderKeys } from "../../orderKey.js";
import { entryId } from "../../helper.js";
import { fromDictionaryRows } from "../../dictionaryRows.js";
import { createAndMergeDoc } from "./doc.js";
import { createAndMergeDomainEntities } from "./domain.entity.js";
import { createAndMergeIndexEntities } from "./index.entity.js";
import { createAndMergeIndexColumnEntities } from "./indexColumn.entity.js";
import { createAndMergeMemoEntities } from "./memo.entity.js";
import { createAndMergeRelationshipEntities } from "./relationship.entity.js";
import { createAndMergeSettings } from "./settings.js";
import { createAndMergeTableEntities } from "./table.entity.js";
import { createAndMergeTableColumnEntities } from "./tableColumn.entity.js";
import { createAndMergeTableGroupEntities } from "./tableGroup.entity.js";
import { createAndMergeTermEntities } from "./term.entity.js";
import { createAndMergeWordEntities } from "./word.entity.js";
import { isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/index.js
function parser(source) {
	const json = source;
	const settings = createAndMergeSettings(json.settings);
	const doc = createAndMergeDoc(json.doc);
	const tableEntities = createAndMergeTableEntities(json.collections?.tableEntities);
	const tableColumnEntities = createAndMergeTableColumnEntities(json.collections?.tableColumnEntities);
	const relationshipEntities = createAndMergeRelationshipEntities(json.collections?.relationshipEntities);
	const indexEntities = createAndMergeIndexEntities(json.collections?.indexEntities);
	const indexColumnEntities = createAndMergeIndexColumnEntities(json.collections?.indexColumnEntities);
	const memoEntities = createAndMergeMemoEntities(json.collections?.memoEntities);
	const tableGroupEntities = createAndMergeTableGroupEntities(json.collections?.tableGroupEntities);
	for (const [list, collection] of HELD_LISTS) if (!Array.isArray(json.doc?.[list])) doc[list] = heldIds(json.collections?.[collection]);
	const words = fromDictionaryRows(json.collections?.wordEntities);
	const terms = fromDictionaryRows(json.collections?.termEntities);
	const domains = fromDictionaryRows(json.collections?.domainEntities);
	const wordEntities = createAndMergeWordEntities(words);
	const termEntities = createAndMergeTermEntities(terms);
	const domainEntities = createAndMergeDomainEntities(domains);
	if (!Array.isArray(json.doc?.wordIds)) doc.wordIds = rowIds(words);
	if (!Array.isArray(json.doc?.termIds)) doc.termIds = rowIds(terms);
	if (!Array.isArray(json.doc?.domainIds)) doc.domainIds = rowIds(domains);
	settleOrderKeys(wordEntities, doc.wordIds);
	settleOrderKeys(termEntities, doc.termIds);
	settleOrderKeys(domainEntities, doc.domainIds);
	clearUnknownDomains(domainEntities, tableColumnEntities, termEntities);
	stackInDocOrder(tableEntities, doc.tableIds, json.collections?.tableEntities, 2);
	stackInDocOrder(memoEntities, doc.memoIds, json.collections?.memoEntities, Math.max(1, ...doc.tableIds.map((id) => tableEntities[id]?.ui.zIndex ?? 0)) + 1);
	stackInDocOrder(tableGroupEntities, doc.tableGroupIds, json.collections?.tableGroupEntities, 1);
	return {
		$schema: "https://raw.githubusercontent.com/dineug/erd-editor/main/json-schema/schema.json",
		version: "3.0.0",
		settings,
		doc,
		collections: {
			tableEntities,
			tableColumnEntities,
			relationshipEntities,
			indexEntities,
			indexColumnEntities,
			memoEntities,
			tableGroupEntities,
			wordEntities,
			termEntities,
			domainEntities
		}
	};
}
var HELD_LISTS = [
	["tableIds", "tableEntities"],
	["relationshipIds", "relationshipEntities"],
	["indexIds", "indexEntities"],
	["memoIds", "memoEntities"],
	["tableGroupIds", "tableGroupEntities"]
];
function heldIds(source) {
	if (!isPlainObject(source)) return [];
	const ids = Object.entries(source).filter(([, value]) => isPlainObject(value)).map(([key, value]) => entryId(key, value)).filter((id) => id !== "");
	return [...new Set(ids)];
}
var rowIds = (values) => [...new Set(values.map((value) => value.id).filter((id) => isString(id) && id !== ""))];
function clearUnknownDomains(domains, ...linked) {
	const known = new Set(Object.keys(domains));
	for (const entities of linked) for (const entity of Object.values(entities)) if (entity.domainId && !known.has(entity.domainId)) entity.domainId = "";
}
function stackInDocOrder(entities, ids, source, base) {
	const stacked = idsWithZIndex(source);
	ids.forEach((id, index) => {
		const entity = entities[id];
		if (!entity || stacked.has(id)) return;
		entity.ui.zIndex = base + index;
		stacked.add(id);
	});
}
function idsWithZIndex(source) {
	const ids = /* @__PURE__ */ new Set();
	if (!isPlainObject(source)) return ids;
	for (const [key, value] of Object.entries(source)) {
		if (!isPlainObject(value)) continue;
		const id = entryId(key, value);
		const ui = value.ui;
		if (isPlainObject(ui) && isNumber(ui.zIndex)) ids.add(id);
		else ids.delete(id);
	}
	return ids;
}
function createSchema() {
	return parser({});
}
//#endregion
export { createSchema, parser };
